import React, { FC, PropsWithChildren } from "react";

/** dnd highlight wrapper */
export const DragHighlightWrapper: FC<PropsWithChildren> = ({ children }) => {
	return (
		<div data-csi-drag-highlight-wrapper>
			{children}
		</div>
	);
};
